import {SmallLoader} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {SubClass, useSubClassQuery} from '../../generated/types';
import {cls, getApolloError} from '../../components/utils';
import {useRoute, navigate} from '../../lib/routes';
import {SubClassView} from './sub-class-view/sub-class-view';
import {NotFoundSeo, isNotFoundError, useNotFound} from '../../lib/seo';
import {SubClassSeo} from './seo';
import {NotFound} from '../../components/not-found';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const SubClassPage: React.FC<Props> = () => {
	const router = useRoute();
	const query = (router?.query || {}) as {id: string; subClassId: string};
	const {id: classId, subClassId} = query;

	const {data, loading, error} = useSubClassQuery({variables: {id: subClassId as string}});
	const subClass = data?.subClass;
	const notFound = !loading && !subClass && isNotFoundError(error);
	useNotFound(notFound);

	return (
		<Layout handleBack={() => navigate('subClasses', {id: classId})}>
			{/* у открытого умения своё SEO — его рисует SubClassView */}
			{subClass && router.routeName !== 'subClassFeature' && (
				<SubClassSeo subClass={subClass as SubClass} classId={classId} />
			)}
			{notFound && <NotFoundSeo />}
			<div className={css.dashboard}>
				{loading && (
					<div className={pageCss.fullSizeBlock}>
						<SmallLoader />
					</div>
				)}
				{notFound ? <NotFound /> : error && <div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>}
				<div className={cls(css.dashboardWrapper, css.showView)}>
					<SubClassView subClass={subClass as SubClass} classId={classId} subClassId={subClassId} />
				</div>
			</div>
		</Layout>
	);
};
